import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {Subject} from 'rxjs/Subject';
import {Config} from '../config';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AboutService {
  public backendUrl: any = new Config();

  constructor(private http: Http) { }

  getInfo() {
    return this.http.get( this.backendUrl.backendUrl + 'info/getInfoList').map(res => res.json());
  }

  getAbout() {
    return this.http.get( this.backendUrl.backendUrl + 'info/about').map(res => res.json());
  }

  getFeatures() {
    return this.http.get( this.backendUrl.backendUrl + 'info/feauters').map(res => res.json());
  }

  getLogo() {
    return this.http.get( this.backendUrl.backendUrl + 'info/getLogo').map(res => res.json());
  }

  getSocial() {
    return this.http.get( this.backendUrl.backendUrl + 'socials/getAll').map(res => res.json());
  }

  getSliderImages() {
    return this.http.get( this.backendUrl.backendUrl + 'sliders/getAll').map(res => res.json());
  }

  getHalls() {
    return this.http.get( this.backendUrl.backendUrl + 'socials/get-halls').map(res => res.json());
  }

  getSpecialOffers() {
    return this.http.get( this.backendUrl.backendUrl + 'specialOffers/getAll').map(res => res.json());
  }

  sendMessage(data) {
    return this.http.post(this.backendUrl.backendUrl + 'orders/send-message', data).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/services/about.service.ts